// extracted by mini-css-extract-plugin
export default {"form":"ContactForm_form__zqkUM","form-before":"ContactForm_form-before__nny1s","form-after":"ContactForm_form-after__P0co6","personal-info":"ContactForm_personal-info__F15xZ"};